<template>
  <!-- Language picker in the sidebar (US 9372): languages in their own names, switches without a page reload -->
  <div class="sb-menu-anchor">
    <button type="button"
            class="sb-item"
            :class="{ 'sb-item--open': open }"
            :aria-expanded="open ? 'true' : 'false'"
            @click="open = !open"
            :aria-label="compact ? $t('app_nav.language') : null"
            qid="navbar-language-select"
    >
      <font-awesome-icon icon="globe" class="sb-item__icon"/>
      <span class="sb-item__text">{{ $t('app_nav.language') }}</span>
      <span class="sb-code">{{ current.toUpperCase() }}</span>
    </button>

    <div class="sb-menu-backdrop" v-if="open" @click="open = false"></div>
    <div class="sb-menu sb-menu--language"
         v-if="open"
         role="menu"
         @keydown.esc="open = false"
    >
      <div class="sb-menu__label">{{ $t('app_nav.language') }}</div>
      <button v-for="language in languages"
              :key="language.value"
              type="button"
              role="menuitemradio"
              :aria-checked="language.value === current ? 'true' : 'false'"
              class="sb-menu__item"
              :class="{ 'sb-menu__item--on': language.value === current }"
              @click="select(language.value)"
              :qid="'language-' + language.value"
      >
        <span class="sb-menu__code">{{ language.value.toUpperCase() }}</span>
        <span class="sb-menu__name" :lang="language.value">{{ language.title }}</span>
        <font-awesome-icon icon="check" v-if="language.value === current"/>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import piincHttp from '@/util/configureAxios.js';

export default {
  name: 'LanguageMenu',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      open: false,
      // Each language in its own name; these are never translated
      languages: [
        { value: 'da', title: 'Dansk' },
        { value: 'de', title: 'Deutsch' },
        { value: 'en', title: 'English' },
        { value: 'fr', title: 'Français' },
      ],
    }
  },
  computed: {
    current() {
      return this.$i18n.locale || 'en';
    }
  },
  methods: {
    // Switches straight away: labels re-render, dates use the new locale, and later API calls send the new
    // language. The app container re-mounts the page, so its data is loaded again in the new language.
    select(language) {
      this.open = false;
      if (language === this.current) {
        return;
      }
      localStorage.setItem('lang', language);
      this.$i18n.locale = language;
      this.$i18n.fallbackLocale = language;
      moment.locale(language);
      piincHttp.defaults.headers['Language'] = language;
      document.documentElement.setAttribute('lang', language);
    }
  }
}
</script>
